window.saleProductsRule = {
    "products":[{"name":"Video Doorbell Pro","model":"V8P"},{"name":"Video Doorbell Ultra","model":"V8S"},{"name":"IndoorCam P1","model":"C2E"},{"name":"IndoorCam P1 Pro","model":"C2P"},{"name":"SolarCam Lite","model":"C7L"},{"name":"SolarCam D1 Lite","model":"C9L"},{"name":"Wireless Cam Lite","model":"C6L"},{"name":"Security Cam P1 Lite","model":"C4L"},{"name":"Outdoor Cam D1 Lite","model":"C5L"},{"name":"Floodlight Cam Pro","model":"L5P"},{"name":"SolarCam D1 Classic","model":"C9C"},{"name":"SolarCam D1 SE","model":"C9E"},{"name":"WirelessCam System Max","model":"C6S"},{"name":"WirelessCam System PRO","model":"C6P"},{"name":"SolarCam System Pro","model":"C7P"},{"name":"SolarCam System Max","model":"C7S"},{"name":"SolarCam D1 Classic Kit","model":"C9C3CA11"},{"name":"Security Cam D1 SE","model":"C5E"},{"name":"SolarCam D1 Max","model":"C9S"}],
    "rules": [
        {
            "url": "/collections/sale-exclusive-offer-a",
            "isExclude": false,
            "saleProduct": [
                {
                    "name": "Video Doorbell Ultra",
                    "model":"V8S",
                    "discount": "0.13",
                    "isExclude": false,
                    "code": "aosuv8s13"
                },
                {
                    "name": "Video Doorbell Pro",
                    "model":"V8P",
                    "discount": "0.14",
                    "isExclude": false,
                    "code": "aosuv8p14"
                },
                {
                    "name": "Floodlight Cam Pro",
                    "model":"L5P",
                    "discount": "0.12",
                    "isExclude": false,
                    "code": "aosul5p12"
                },
                {
                    "name": "SolarCam Lite",
                    "model":"C7L",
                    "discount": "0.07",
                    "isExclude": false,
                    "code": "aosuc7l7"
                },
                {
                    "name": "SolarCam D1 SE",
                    "model":"C9E",
                    "discount": "0.15",
                    "isExclude": false,
                    "code": "aosuc9e15"
                },
                {
                    "name": "SolarCam D1 Classic Kit",
                    "model":"C9C3CA11",
                    "discount": "0.1",
                    "isExclude": false,
                    "code": "aosuc9cweb10"
                }
            ]
        },
        {
            "url": "/collections/sale-exclusive-offer-b1-1",
            "isExclude": true,
            "saleProduct": [
                {
                    "name": "Video Doorbell Ultra",
                    "model":"V8S",
                    "discount": "0.13",
                    "isExclude": true,
                    "code": "aosuv8s13"
                },
                {
                    "name": "Floodlight Cam Pro",
                    "model":"L5P",
                    "discount": "0.12",
                    "isExclude": true,
                    "code": "aosul5p12"
                },
                {
                    "name": "Security Cam D1 SE",
                    "model":"C5E",
                    "discount": "0.15",
                    "isExclude": true,
                    "code": "aosuc5e15"
                },
                {
                    "name": "SolarCam D1 Lite",
                    "model":"C9L",
                    "discount": "0.12",
                    "isExclude": true,
                    "code": "aosuc9l12"
                },
                {
                    "name": "WirelessCam System Max",
                    "model":"C6S",
                    "discount": "0.12",
                    "isExclude": true,
                    "code": "aosuc6s12"
                },
                {
                    "name": "SolarCam D1 Classic Kit",
                    "model":"C9C3CA11",
                    "discount": "0.1",
                    "isExclude": true,
                    "code": "aosuc9cweb10"
                }
            ]
        },
        {
            "url": "/collections/sale-exclusive-offer-b1-2",
            "isExclude": true,
            "saleProduct": [
                {
                    "name": "Video Doorbell Ultra",
                    "model":"V8S",
                    "discount": "0.13",
                    "isExclude": true,
                    "code": "aosuv8s13"
                },
                {
                    "name": "Video Doorbell Pro",
                    "model":"V8P",
                    "discount": "0.14",
                    "isExclude": true,
                    "code": "aosuv8p14"
                },
                {
                    "name": "Floodlight Cam Pro",
                    "model":"L5P",
                    "discount": "0.12",
                    "isExclude": true,
                    "code": "aosul5p12"
                },
                {
                    "name": "Security Cam P1 Lite",
                    "model":"C4L",
                    "discount": "0.05",
                    "isExclude": true,
                    "code": "aosuc4l5"
                },
                {
                    "name": "SolarCam D1 Classic",
                    "model":"C9C",
                    "discount": "0.03",
                    "isExclude": true,
                    "code": "aosuc9csingle3"
                },
                {
                    "name": "SolarCam D1 Classic Kit",
                    "model":"C9C3CA11",
                    "discount": "0.1",
                    "isExclude": true,
                    "code": "aosuc9cweb10"
                }
            ]
        },
        {
            "url": "/collections/sale-exclusive-offer-b2",
            "isExclude": false,
            "saleProduct": [
                {
                    "name": "Video Doorbell Ultra",
                    "model":"V8S",
                    "discount": "0.13",
                    "isExclude": false,
                    "code": "aosuv8s13"
                },
                {
                    "name": "Video Doorbell Pro",
                    "model":"V8P",
                    "discount": "0.14",
                    "isExclude": false,
                    "code": "aosuv8p14"
                },
                {
                    "name": "Floodlight Cam Pro",
                    "model":"L5P",
                    "discount": "0.12",
                    "isExclude": false,
                    "code": "aosul5p12"
                },
                {
                    "name": "IndoorCam P1 Pro",
                    "model":"C2P",
                    "discount": "0.05",
                    "isExclude": false,
                    "code": "aosuc2p5"
                },
                {
                    "name": "Security Cam D1 SE",
                    "model":"C5E",
                    "discount": "0.15",
                    "isExclude": false,
                    "code": "aosuc5e15"
                }
            ]
        },
        {
            "url": "/collections/sale-exclusive-offer-c",
            "isExclude": false,
            "saleProduct": [
                {
                    "name": "Floodlight Cam Pro",
                    "model":"L5P",
                    "discount": "0.12",
                    "isExclude": false,
                    "code": "aosul5p12"
                },
                {
                    "name": "Security Cam D1 SE",
                    "model":"C5E",
                    "discount": "0.15",
                    "isExclude": false,
                    "code": "aosuc5e15"
                },
                {
                    "name": "SolarCam D1 Max",
                    "model":"C9S",
                    "discount": "0.1",
                    "isExclude": false,
                    "code": "aosuc9s10"
                },
                {
                    "name": "SolarCam D1 Classic Kit",
                    "model":"C9C3CA11",
                    "discount": "0.1",
                    "isExclude": false,
                    "code": "aosuc9cweb10"
                },
                {
                    "name": "SolarCam System Max",
                    "model":"C7S",
                    "discount": "0.14",
                    "isExclude": false,
                    "code": "aosuc7s14"
                },
                {
                    "name": "SolarCam System Pro",
                    "model":"C7P",
                    "discount": "0.13",
                    "isExclude": false,
                    "code": "aosuc7p13"
                }
            ]
        },
        {
            "url": "/collections/sale-exclusive-offer-d",
            "isExclude": false,
            "saleProduct": [
                {
                    "name": "Video Doorbell Ultra",
                    "model":"V8S",
                    "discount": "0.13",
                    "isExclude": false,
                    "code": "aosuv8s13"
                },
                {
                    "name": "Video Doorbell Pro",
                    "model":"V8P",
                    "discount": "0.14",
                    "isExclude": false,
                    "code": "aosuv8p14"
                },
                {
                    "name": "SolarCam D1 Max",
                    "model":"C9S",
                    "discount": "0.1",
                    "isExclude": false,
                    "code": "aosuc9s10"
                },
                {
                    "name": "SolarCam D1 Classic Kit",
                    "model":"C9C3CA11",
                    "discount": "0.1",
                    "isExclude": false,
                    "code": "aosuc9cweb10"
                },
                {
                    "name": "SolarCam System Max",
                    "model":"C7S",
                    "discount": "0.14",
                    "isExclude": false,
                    "code": "aosuc7s14"
                },
                {
                    "name": "SolarCam System Pro",
                    "model":"C7P",
                    "discount": "0.13",
                    "isExclude": false,
                    "code": "aosuc7p13"
                }
            ]
        },
        {
            "url": "/collections/sale-exclusive-offer-e",
            "isExclude": true,
            "saleProduct": [
                {
                    "name": "Video Doorbell Ultra",
                    "model":"V8S",
                    "discount": "0.13",
                    "isExclude": true,
                    "code": "aosuv8s13"
                },
                {
                    "name": "Video Doorbell Pro",
                    "model":"V8P",
                    "discount": "0.14",
                    "isExclude": true,
                    "code": "aosuv8p14"
                },
                {
                    "name": "Floodlight Cam Pro",
                    "model":"L5P",
                    "discount": "0.12",
                    "isExclude": true,
                    "code": "aosul5p12"
                },
                {
                    "name": "Security Cam D1 SE",
                    "model":"C5E",
                    "discount": "0.15",
                    "isExclude": true,
                    "code": "aosuc5e15"
                },
                {
                    "name": "SolarCam D1 Max",
                    "model":"C9S",
                    "discount": "0.1",
                    "isExclude": true,
                    "code": "aosuc9s10"
                },
                {
                    "name": "SolarCam System Max",
                    "model":"C7S",
                    "discount": "0.14",
                    "isExclude": true,
                    "code": "aosuc7s14"
                },
                {
                    "name": "SolarCam System Pro",
                    "model":"C7P",
                    "discount": "0.13",
                    "isExclude": true,
                    "code": "aosuc7p13"
                },
                {
                    "name": "SolarCam D1 Classic Kit",
                    "model":"C9C3CA11",
                    "discount": "0.1",
                    "isExclude": true,
                    "code": "aosuc9cweb10"
                }
            ]
        },
        {
            "url": "/collections/sale-exclusive-offer-f1",
            "isExclude": false,
            "saleProduct": [
                {
                    "name": "Video Doorbell Ultra",
                    "model":"V8S",
                    "discount": "0.13",
                    "isExclude": false,
                    "code": "aosuv8s13"
                },
                {
                    "name": "Video Doorbell Pro",
                    "model":"V8P",
                    "discount": "0.14",
                    "isExclude": false,
                    "code": "aosuv8p14"
                },
                {
                    "name": "Floodlight Cam Pro",
                    "model":"L5P",
                    "discount": "0.12",
                    "isExclude": false,
                    "code": "aosul5p12"
                },
                {
                    "name": "SolarCam Lite",
                    "model":"C7L",
                    "discount": "0.07",
                    "isExclude": false,
                    "code": "aosuc7l7"
                },
                {
                    "name": "SolarCam D1 Max",
                    "model":"C9S",
                    "discount": "0.1",
                    "isExclude": false,
                    "code": "aosuc9s10"
                },
                {
                    "name": "SolarCam D1 Classic Kit",
                    "model":"C9C3CA11",
                    "discount": "0.1",
                    "isExclude": false,
                    "code": "aosuc9cweb10"
                }
            ]
        }
    ]
}
window.findByTitle = (array, name,url) => {
    let rules = window.saleProductsRule.rules.find(entity => entity.url === url);
    if(!rules){
      return null;
    }
    let product = rules.saleProduct.find(entity => entity.name === name);
    if(!product){
      return null;
    }
    if(product.isExclude && localStorage.getItem('DeviceList')){
      var deviceList = JSON.parse(localStorage.getItem('DeviceList'));
      if(deviceList.list.find(entity => entity.ori_model === product.model)){
        return null;
      }
    }
    return product;
    /*for (let i = 0; i < array.length; i++) {
        const found = array[i].saleProduct.find(item => item.name === name);
        if (found) return found;
      }
    return null;*/
}